import { render, staticRenderFns } from "./mohe.vue?vue&type=template&id=86f2ee42&scoped=true"
var script = {}
import style0 from "./mohe.vue?vue&type=style&index=0&id=86f2ee42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f2ee42",
  null
  
)

export default component.exports